import { theme } from "@clearabee/ui-library-native";
import { Button } from "components/Core/Button/Button";
import { Input } from "components/Core/Input/Input";
import { SKIP_WASTE_TYPES } from "lib/constants/skipWasteTypes";
import { Form, useForm } from "lib/hooks/useForm";
import { useQuestionContext } from "lib/providers/questionProvider";
import React from "react";
import { useTranslation } from "react-i18next";
import { Platform, View } from "react-native";
import { z } from "zod";
import { FormState } from "./Skips.validation";

export const WasteType = (): React.ReactElement => {
  const [translate] = useTranslation();
  const context = useQuestionContext<FormState>();
  const wasteType = context.get("wasteType") ?? "";
  const form = useForm({
    defaultValues: { wasteType },
    validationSchema: z.object({ wasteType: z.string().min(1) }),
    onSubmit: ({ wasteType }) => {
      return context.set("wasteType", wasteType).open("exchange");
    },
  });

  return (
    <Form state={form} useForm={false}>
      {({ Field }) => (
        <View style={{ maxWidth: 300, width: "100%", alignSelf: "center" }}>
          <Field
            name="wasteType"
            errorStyles={Platform.select({
              web: {
                position: "absolute",
                bottom: -29,
              },
              default: {
                marginBottom: -theme.spacing.xsmall,
              },
            })}
            labelStyles={{
              color:
                Platform.OS === "web"
                  ? theme.colors.light.base
                  : theme.colors.dark.base,
            }}
            invertErrorColors
            errorBackground
            label={translate("common.wasteType")}
          >
            {({ field }) => (
              <Input.Select
                {...field}
                options={SKIP_WASTE_TYPES.map(({ label, value }) => ({
                  label: translate(label),
                  value,
                }))}
                placeholder={translate("common.form.placeholder.wasteType")}
                usePortal
              />
            )}
          </Field>
          <Button
            type="submit"
            color="warning"
            size="medium"
            styles={{
              marginTop: theme.spacing.medium,
              height: 54,
              alignSelf: "center",
            }}
            onClick={form.submitForm}
          >
            {translate("common.continue")}
          </Button>
        </View>
      )}
    </Form>
  );
};
